import { render, staticRenderFns } from "./Portalinformationen.vue?vue&type=template&id=bd55243a&scoped=true&"
import script from "./Portalinformationen.vue?vue&type=script&lang=js&"
export * from "./Portalinformationen.vue?vue&type=script&lang=js&"
import style0 from "./Portalinformationen.vue?vue&type=style&index=0&id=bd55243a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd55243a",
  null
  
)

export default component.exports